import React, { useState } from "react";
import { Modal as AntModal, Button, message, Space } from "antd";
import styled from "styled-components";
import { IconRejectLight } from "@assets";
import { api } from "@api";
import { useAtom } from "jotai";
import { orderCount } from "../../../../utils/atom";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-close-icon svg {
    font-size: 24px;
  }

  .ant-modal-title {
    color: #1e1e1e;
    font-size: 24px;
    font-weight: 700;
  }

  .ant-modal-body {
    font-size: 16px;
    font-weight: 400;
    color: #1d1014;
  }

  .ant-modal-footer {
    .ant-btn {
      width: 100%;
      height: 56px;
    }

    .ant-btn-primary {
      background: #f00 !important;
    }

    .ant-space {
      width: 100%;
      gap: 16px !important;

      .ant-space-item {
        flex: 1;
      }
    }
  }
`;

const RejectModal = ({ id, open, handleClose, successCallback }) => {
  const [loading, setLoading] = useState(false);
  const [orderStatus, setOrderStatus] = useAtom(orderCount);
  
  const {t} = useTranslation();

  const handleReject = () => {
    if (!loading) {
      setLoading(true);
      api
        .rejectOrder(id)
        .then(() => {
          setLoading(false);
          message.success("Rejected the order successfully!");
          handleClose();
          successCallback();
          setOrderStatus(!orderStatus);
        })
        .catch((error) => {
          setLoading(false);
          message.error(error);
        });
    }
  };

  const onCancel = () => {
    !loading && handleClose();
  };

  return (
    <Modal
      centered
      width={500}
      open={open}
      onCancel={onCancel}
      title="Reject Order?"
      footer={
        <Space>
          <Button type="default" onClick={onCancel}>
            {t('cancel')}
          </Button>
          <Button
            type="primary"
            icon={<IconRejectLight />}
            onClick={handleReject}
            loading={loading}
          >
            {t('reject')}
          </Button>
        </Space>
      }
    >
      {t('reject_text')}
    </Modal>
  );
};

export default RejectModal;
